import * as commonLogic from './CommonLogic';
import * as cookies from './Cookies';
import * as exceptionHandler from './ExceptionHandler';
import * as apiWrapperOpenId from './APIWrapperOpenId';
import * as apiWrapper from './APIWrapper';

/**
 * Authentication
 */
export function Authentication() {
  // Auth0からリダイレクト時のみ、URLアンカーから取得
  const urlAccessToken = commonLogic.getAccessTokenFromURL();
  const urlIdToken = commonLogic.getIdTokenFromURL();
  const urlState = commonLogic.getStateFromURL();

  const urlError = commonLogic.getErrorFromURL();
  const urlErrorDescription = commonLogic.getErrorDescriptionFromURL();
  
  console.log('urlError=' + urlError);
  console.log('urlErrorDescription=' + urlErrorDescription);
  if (urlError && urlErrorDescription){
    // 認証エラー
    deleteSessionCookie();
    if (urlError === 'unauthorized' && urlErrorDescription === 'user is blocked'){
      // ユーザーロック
      authorize(true, false)
      javascript_die();
    }else{ 
      // その他の認証エラーの場合
      authorize(false, true)
      javascript_die();
    }
  }

  if (sessionStorage.getItem('loginFailerFlg') == 1) {
    sessionStorage.removeItem('loginFailerFlg');
    return;
  }
  sessionStorage.removeItem('loginFailer');
  sessionStorage.removeItem('loginFailerFlg');
  // 認証情報が残っているか確認
  if (urlAccessToken && urlIdToken) { //　初回ログイン（Cookieにユーザー情報が無い場合）
    // stateチェック
    const cookieState = cookies.getItem('state');
    console.log('state(cookies):' + cookieState);
    console.log('state(url):' + urlState);
    if (!urlState || urlState != cookieState) {
      // stateチェック済みフラグを取得
      const cookieStateChecked = cookies.getItem('stateChecked');
      if (!cookieStateChecked) {
        // チェック済みでない場合はチェック済みフラグを設定して認証処理を実行
        cookies.setItem('stateChecked', true);
        console.log('authenticate again');
        if (ENABLED_AUTHORIZE) {
          authorize();
          javascript_die();
        }
      }
      // チェック済みの場合はエラー
      console.log('state does not match');
      deleteSessionCookie()
      location.replace(PORTAL_URL_END_SESSION + '?error_flg=1');
      javascript_die();
    }
    
    cookies.setItem('access_token', urlAccessToken);
    apiWrapperOpenId.checkContract(urlIdToken, (err, result) => {
      if (err) {
        sessionStorage.setItem('loginFailer', err.message);
        sessionStorage.setItem('loginFailerFlg', 1);

        const redirectURL = location.href.split('#')[0];
        if (redirectURL != null) {
          location.replace(redirectURL);
        } else {
          location.replace(location.href);
        }
      } else {
        console.log("apiWrapper.getLogin");
        apiWrapper.getLogin((err, term) => {
          if (err) {
            sessionStorage.setItem('loginFailer', err.message);
            sessionStorage.setItem('loginFailerFlg', 1);
            cookies.removeItem('access_token');
          } else {
            cookies.setItem('access_token', urlAccessToken);
            cookies.setItem('id_token', urlIdToken);
          }
          // 認証後のURLフラグメントをエンドユーザーに見せないため、自分自身にRedirectする
          const redirectURL = location.href.split('#')[0];
          if (redirectURL != null) {
            location.replace(redirectURL);
          } else {
            location.replace(location.href);
          }
        });
      }
    });
    javascript_die();

  } else { // K-TACsにアクセス時 or 通常アクセス時
    const cookieAccessToken = cookies.getItem('access_token');
    const cookieIdToken = cookies.getItem('id_token');
    if (!cookieAccessToken || !cookieIdToken) { 
      // Cookie上にユーザ情報がない場合
      console.log('userinfo does not exist in cookies');
      if (ENABLED_AUTHORIZE) {
        authorize();
        javascript_die();
      }
    } else {
      console.log('userinfo for cookies exists');
    }
  }
}

/**
 * TriggerUserName
 * @param {*} action
 */
export function TriggerUserName(action) {
  const cookieAccessToken = cookies.getItem('access_token');
  const cookieIdToken = cookies.getItem('id_token');
  if (cookieAccessToken && cookieIdToken) {
    action.checkContract(cookieIdToken);
  }
}
/**
 * checkLoginFailer
 * @param {*} prop
 */
export function checkLoginFailer(prop) {
  
  if (sessionStorage.getItem('loginFailer')) {
    prop.AppData.error = new Error(sessionStorage.getItem('loginFailer'));
    sessionStorage.removeItem('loginFailer');
  }
}
/**
 * authorize
 * @param {Boolean} isBlock // ユーザブロック判定フラグ
 * * @param {Boolean} isOther // その他認証エラーフラグ
 */
export function authorize(isBlock = false, isOther = false) {
  // state, nonceを作成
  const state = commonLogic.getUniqueStr();
  const nonce = commonLogic.getUniqueStr();
  // state, nonceをCookieに保存
  cookies.setItem('state', state);
  cookies.setItem('nonce', nonce);

  exceptionHandler.cancel();
  const loginUrl = AUTH0_URL_AUTHORIZE + AUTH0_URL_AUTHORIZE_PARAM + `&state=${state}&nonce=${nonce}`;

  if (isBlock){
    // ログイン画面表示（ユーザブロックエラー）
    console.log('User account is locked');
    console.log('redirect url:' + loginUrl + '&error_description=blocked');
    location.replace(loginUrl + '&error_description=blocked');
  } else if (isOther){
    // ログイン画面表示（その他認証エラー）
    console.log('Other error');
    console.log('redirect url:' + loginUrl + '&error_description=otherError');
    location.replace(loginUrl + '&error_description=otherError');
  } else {
    // A00002:認可API(Implicit Flow)
    console.log('redirect Authorization API');
    console.log('redirect url:' + loginUrl);
    location.replace(loginUrl);
  }
  
  
}

/**
 * deleteSessionCookie
 * ログアウト・エラー処理の前に実行
 */
export function deleteSessionCookie() {
  // クッキーの削除
  cookies.removeItem('access_token');
  cookies.removeItem('id_token');
  cookies.removeItem('state');
  cookies.removeItem('nonce');
  cookies.removeItem('userId');
  cookies.removeItem('userName');
  cookies.removeItem('iPlanetDirectoryPro');
  cookies.removeItem('stateChecked');
  cookies.removeItem('checkedNonce');
  cookies.removeItem('isLogin');
  // セッションの削除
  sessionStorage.removeItem('recoverLastSearch');
  sessionStorage.removeItem('condition');
  sessionStorage.removeItem('gmnID');
  sessionStorage.removeItem('reAuthenticationCnt');
  sessionStorage.removeItem('reAuthenticationCntOpenId');
}